import React, { useEffect, useState } from 'react';
import { DateContainer, DateLabel, InputsContainer } from '../index.styled';
import { DatePicker } from 'components/Input';
import utils from 'utils';
import { Checkbox } from 'components/Buttons';
import { useSelector } from 'react-redux';
import selectors from 'state/selectors';
import { InputLabel } from 'components/Input/TextInput';

type props = {
  label: string;
  date: Date | null;
  fromDate: Date | null;
  toDate: Date | null;
  setDate: (date: Date | string | null) => void;
  setFromDate: (date: Date | string | null) => void;
  setToDate: (date: Date | string | null) => void;
  isCheckboxVisible: boolean;
  hasFeedback?: boolean;
  feedbackMessage?: string;
};

const DateRange = ({
  label,
  date,
  fromDate,
  toDate,
  setDate,
  setFromDate,
  setToDate,
  isCheckboxVisible,
  hasFeedback,
  feedbackMessage,
}: props) => {
  const t = utils.intl.useTranslator();
  const dateFormat = useSelector(selectors.user.getUserPreference).dateFormat;

  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    if (fromDate || toDate) {
      setIsChecked(true);
    }
  }, [fromDate, toDate]);

  return (
    <div>
      {isChecked ? (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <InputsContainer>
            <InputLabel> {label}</InputLabel>
            <DateContainer>
              <DateLabel>{t('from:')}</DateLabel>
              <DatePicker
                selected={fromDate}
                onChange={(date) => setFromDate(date ? utils.date.formatDateForDb(date) : null)}
                dateFormat={dateFormat}
                placeholderText={dateFormat?.toUpperCase()}
                maxDate={toDate || null}
                isClearable
                inputWidth="120px"
                portal
                hasFeedback={hasFeedback}
                feedbackMessage={feedbackMessage || undefined}
              />
            </DateContainer>
          </InputsContainer>
          <InputsContainer>
            <InputLabel />
            <DateContainer>
              <DateLabel>{t('to:')}</DateLabel>
              <DatePicker
                selected={toDate}
                onChange={(date) => setToDate(date ? utils.date.formatDateForDb(date) : null)}
                dateFormat={dateFormat}
                placeholderText={dateFormat?.toUpperCase()}
                minDate={fromDate}
                isClearable
                inputWidth="120px"
                portal
                hasFeedback={hasFeedback}
                feedbackMessage={feedbackMessage || undefined}
              />
            </DateContainer>
          </InputsContainer>
        </div>
      ) : (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <InputLabel> {label}</InputLabel>
          <DatePicker
            selected={date}
            onChange={(date) => setDate(date ? utils.date.formatDateForDb(date) : null)}
            dateFormat={dateFormat}
            placeholderText={dateFormat?.toUpperCase()}
            maxDate={toDate}
            isClearable
            portal
            hasFeedback={hasFeedback}
            feedbackMessage={feedbackMessage || undefined}
          />
        </div>
      )}

      {isCheckboxVisible && (
        <Checkbox
          label={t('Range')}
          name="Range"
          isActive={isChecked}
          action={(value) => {
            if (value && date) {
              setDate(null);
            }
            if ((!value && fromDate) || toDate) {
              setFromDate(null);
              setToDate(null);
            }
            setIsChecked(value);
          }}
          wrapperStyle={{ margin: '10px 0', width: '100%', justifyContent: 'center' }}
        />
      )}
    </div>
  );
};

export default DateRange;
